"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
class StorageClient extends base_client_1.ApiClient {
    constructor(config) {
        const STORAGE_URL = config.baseURL || process.env.STORAGE_SERVICE_URL;
        //Initially AuthEngine will be UNKNOWN,
        //as we want consumer of package to set the AuthEngine
        let apiClientConfig = {
            //AuthEngine.UNKNOWN will never be set in ApiClient
            authEngine: core_auth_1.AuthEngine.UNKNOWN,
        };
        if (!STORAGE_URL) {
            commons_logs_1.log.warn("STORAGE_SERVICE_URL environment variable is not set");
        }
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            apiClientConfig = {
                authEngine: core_auth_1.AuthEngine.COGNITO_INTERNAL,
                tokenRefreshFn: tokenHandler.getTokenFn(),
            };
        }
        else {
            apiClientConfig = {
                authEngine: config.authEngine,
            };
        }
        apiClientConfig = Object.assign(Object.assign({}, config), apiClientConfig);
        super(Object.assign(Object.assign({}, apiClientConfig), { baseURL: `${STORAGE_URL}/v1/` }));
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        this.handleStorageError = (error) => {
            throw this.maybeGetDeliverrError(error) || this.maybeGetNetworkError(error) || this.getUnknownError(error);
        };
    }
    async getStorageWarehouses() {
        return this.get(`/storage/warehouses`).catch(this.handleStorageError);
    }
    async getNearestStorageWarehouse(address) {
        return this.post(`/storage/warehouses/nearest`, address).catch(this.handleStorageError);
    }
    async getStorageInbounds(sellerId) {
        return this.get(`/storage/inbounds?sellerId=${sellerId}`).catch(this.handleStorageError);
    }
    async getStorageInboundByShippingPlanId(sellerId, shippingPlanId, options = {}) {
        var _a, _b;
        const includeInboundExtraDetails = (_a = options.includeInboundExtraDetails) !== null && _a !== void 0 ? _a : true;
        const fetchWarehouseAppointmentLink = (_b = options.fetchWarehouseAppointmentLink) !== null && _b !== void 0 ? _b : false;
        return this.get(`/storage/inbounds?sellerId=${sellerId}&shippingPlanId=${shippingPlanId}&includeInboundExtraDetails=${includeInboundExtraDetails}&fetchWarehouseAppointmentLink=${fetchWarehouseAppointmentLink}`).catch(this.handleStorageError);
    }
    async getStorageInboundByBookingId(sellerId, bookingID) {
        return this.get(`/storage/inbounds?sellerId=${sellerId}&bookingID=${bookingID}`).catch(this.handleStorageError);
    }
    async getStorageTransferOrder(sellerId, transferOrderId) {
        return this.get(`storage/transfer?storageTransferOrderId=${transferOrderId}&sellerId=${sellerId}`).catch(this.handleStorageError);
    }
    async createStorageInbound(storageInboundRequest) {
        return this.post(`/storage/inbounds`, storageInboundRequest).catch(this.handleStorageError);
    }
    async createExternalStorageInboundOrder(storageInboundRequest) {
        return this.post(`/public-api/inbounds`, storageInboundRequest).catch(this.handleStorageError);
    }
    async patchStorageInbound(sellerId, storageInboundOrderId, storageInboundOrderRequest) {
        return this.patch(`/storage/inbounds?sellerId=${sellerId}&storageInboundOrderId=${storageInboundOrderId}`, storageInboundOrderRequest).catch(this.handleStorageError);
    }
    async archiveStorageInbound(sellerId, shippingPlanId) {
        return this.delete(`/storage/inbounds?sellerId=${sellerId}&shippingPlanId=${shippingPlanId}`).catch(this.handleStorageError);
    }
    async getRates() {
        return this.get(`/storage/rates`).catch(this.handleStorageError);
    }
    async generateLabels(generateLabelRequest) {
        return this.post(`/storage/labels`, generateLabelRequest).catch(this.handleStorageError);
    }
    async estimatePalletCount(estimatePalletRequest) {
        return this.post(`/storage/estimate/pallet-count`, estimatePalletRequest).catch(this.handleStorageError);
    }
    async createStorageTransferOrder(storageTransferOrderRequest) {
        return this.post(`/storage/transfer`, storageTransferOrderRequest).catch(this.handleStorageError);
    }
    async updateStorageTransferOrder(storageTransferOrderRequest, storageTransferOrderId) {
        return this.put(`/storage/transfer/${storageTransferOrderId}`, storageTransferOrderRequest).catch(this.handleStorageError);
    }
    async submitStorageTransferOrder(storageTransferOrderSubmitRequest) {
        return this.post(`/storage/transfer/submit`, storageTransferOrderSubmitRequest).catch(this.handleStorageError);
    }
    async validateAndReturnInventoryAvailableInEachStorageWarehouse(dskuQuantities, poolName) {
        return this.post(`/storage/inventory/validate`, dskuQuantities, { poolName }).catch(this.handleStorageError);
    }
    async getUnifiedAvailablePackInventoryByWarehouse(dskuQuantities, isEachPickOrder, poolName) {
        return this.post(`/storage/inventory/unified`, dskuQuantities, {
            isEachPickOrder,
            poolName,
        }).catch(this.handleStorageError);
    }
    async getStorageToEcomRates(storageToEcomRateRequest) {
        return this.post(`/storage/rates/transfer`, storageToEcomRateRequest !== null && storageToEcomRateRequest !== void 0 ? storageToEcomRateRequest : {}).catch(this.handleStorageError);
    }
    async getCaseConfig(dsku) {
        const dskuParamValue = (dsku !== null && dsku !== void 0 ? dsku : []).map((orig) => '"' + orig + '"').join(",");
        return this.get(`/storage/product/case-config?dsku=[${dskuParamValue}]`).catch(this.handleStorageError);
    }
    async getSellerConfig(sellerId) {
        return this.get(`/storage/seller/config/${sellerId}`).catch(this.handleStorageError);
    }
    async getSellersConfig(sellerIds) {
        return this.post(`/storage/seller/config/search`, { sellerIds }).catch(this.handleStorageError);
    }
    async setShipmentStatus(asnId, warehouseId, timestamp) {
        return this.put(`/storage/ops/inbounds/${asnId}/arrived`, {
            warehouseId,
            timestamp,
        }).catch(this.handleStorageError);
    }
    async getStorageOutboundBillingInfo(storageOutboundBillingInfoRequest) {
        return this.post("storage/billing/outbound/fetch", storageOutboundBillingInfoRequest).catch(this.handleStorageError);
    }
    async getStorageInboundByAsnId(asnId, warehouseId, requestBatchId) {
        return this.get(`/storage/ops/inbounds/${asnId}/latest`, { warehouseId, requestBatchId }, { "x-warehouse-id": warehouseId }).catch(this.handleStorageError);
    }
    async archiveStorageTransfer(sellerId, storageTransferOrderId) {
        return this.delete(`/storage/transfer?sellerId=${sellerId}&storageTransferOrderId=${storageTransferOrderId}`).catch(this.handleStorageError);
    }
    async getAllStorageTransferOrders(storageTransferOrderSearchRequest) {
        return this.post(`/storage/transfer/search`, storageTransferOrderSearchRequest).catch(this.handleStorageError);
    }
    async createOrUpdateIntransitInventoryTrackingStatusForOrder(request) {
        return this.post(`/storage/inventory/track/ecom/in-transit`, request).catch(this.handleStorageError);
    }
    /**
     * Fetches the total inventory of products in transit by dsku.
     *
     * @param
     * The request payload containing the necessary information of dskus and days to fetch the
     * product in transit inventory
     * @returns
     * This API returns the sum of all expected units and received units of the products in transit
     * during that period of time
     *
     */
    async fetchProductInTransitInventory(request) {
        return this.post(`/storage/inventory/in-transit/`, request).catch(this.handleStorageError);
    }
    /**
     * This API is in Storage Ops Routes. Hence only meant for admin and warehouse-portal calls.
     * @param warehouseId
     * @param productCasePackData
     * @returns
     */
    async createPackInProductAndInbound(warehouseId, productCasePackData) {
        return this.post(`storage/ops/inbounds/pack?warehouseId=${warehouseId}`, productCasePackData).catch(this.handleStorageError);
    }
    async printStoragePalletLabelsPdf(numLabels) {
        const url = `/storage/labels/pallets`;
        return this.axios
            .request({
            method: "post",
            url,
            data: { numLabels },
            responseType: "blob",
        })
            .then((response) => new Blob([response.data], { type: "application/pdf" }))
            .catch(this.handleStorageError);
    }
    async getReplenishmentStatusByBookingId(bookingID, lastMilestoneTimestamp) {
        return this.get(`/storage/replenishment/${bookingID}/status`, {
            lastMilestoneTimestamp,
        }).catch(this.handleStorageError);
    }
    async createReserveStorageOrderBasedOnBookingType(createRSOrderRequest) {
        return this.post("/storage/replenishment/order", createRSOrderRequest).catch(this.handleStorageError);
    }
    async updateReserveStorageAndReplenishmentOrder(storageInboundOrderId, updateRSOrderRequest) {
        return this.put(`/storage/replenishment/order/${storageInboundOrderId}`, updateRSOrderRequest).catch(this.handleStorageError);
    }
    async submitReplenishmentOrder(bookingId) {
        // eslint-disable-next-line @typescript-eslint/ban-types
        return this.put(`/storage/replenishment/order/${bookingId}/submit`, {}).catch(this.handleStorageError);
    }
    async getReplenishmentQuote(replenishmentQuoteRequest) {
        return this.post("/storage/replenishment/quote", replenishmentQuoteRequest).catch(this.handleStorageError);
    }
    async getRankedStorageWarehousesForInbounds(sellerId, address) {
        return await this.post(`/storage/warehouses/inbounds/${sellerId}/withNearestWarehouse`, address);
    }
    async getStorageWarehousesForInbounds(sellerId) {
        return this.get(`/storage/warehouses/inbounds/${sellerId}`).catch(this.handleStorageError);
    }
}
exports.StorageClient = StorageClient;
//# sourceMappingURL=StorageClient.js.map